export const push1Columns = [{
  label: '回收说明',
  value: 'note',
  align: 'center',
  width: '200px',
  tooltip: false
},{
  label: '红包原价(元)',
  value: 'originalReward',
  align: 'center'
},{
  label: '红包折后价(元)',
  value: 'discountReward',
  align: 'center'
},{
  label: '回收数量',
  value: 'recoveryQuantity',
  align: 'center'
},{
  label: '红包总额(元)',
  value: 'discountAmount',
  align: 'center'
}]

export const push2Columns = [{
  label: '回收说明',
  value: 'note',
  width: '200px',
  align: 'center',
  tooltip: false
},{
  label: '已回收数量',
  value: 'recoveredAmount',
  align: 'center'
},{
  label: '已审核数量',
  value: 'auditedAmount',
  align: 'center'
},{
  label: '已审核拒绝数量',
  value: 'refusedAmount',
  width: '100px',
  align: 'center'
},{
  label: '待审核数量',
  value: 'auditingAmount',
  align: 'center'
},{
  label: '已花费',
  value: 'spentAmount',
  align: 'center'
},{
  label: '红包余额(元)',
  value: 'balanceAmount',
  align: 'center'
}]

export const push3Columns = [{
  label: '回收说明',
  value: 'note',
  width: '200px',
  align: 'center',
  tooltip: false
},{
  label: '可退款的样本数量',
  value: 'refundableSamples',
  align: 'center'
},{
  label: '红包折后价(元)',
  value: 'discountReward',
  align: 'center'
},{
  label: '退款金额(元)',
  value: 'refundableReward',
  align: 'center'
}]
